(function () {
  'use strict';

  angular
    .module('app.product-share', [])

    .directive('socialshare', function () {
      return {
        restrict: 'A',
        scope: true,
        bindToController: {
          socialshare: '@',
          socialshareUrl: '@',
          socialshareText: '@?',
          socialshareMedia: '@?',
          socialshareHashtags: '@?',
          socialshareEmail: '@?',
          modalTitle: '@',
          resultMessage: '@?'
        },
        /* @ngInject */
        controller: ["$element", "$window", "ModalService", function ($element, $window, ModalService) {
          var ctrl = this;

          var appId = '143402606292797';

          $element.on('click', function () {
            switch (ctrl.socialshare) {
              case 'facebook':
                facebookShare();
                break;
              case 'pinterest':
                pinterestShare();
                break;
              case 'twitter':
                twitterShare();
                break;
              case 'googleplus':
                googleplusShare();
                break;
              case 'email':
                emailShare();
                break;
            }
          });

          function facebookShare() {
            var winWidth = 673,
              winHeight = 413;

            var urlString = 'https://www.facebook.com/dialog/share?app_id=' + appId + '&display=popup';
            urlString += '&href=' + encodeURIComponent(ctrl.socialshareUrl);
            urlString += ctrl.socialshareText ? '&title=' + encodeURIComponent(ctrl.socialshareText) : '';
            urlString += ctrl.socialshareHashtags ? '&hashtag=' + encodeURIComponent(ctrl.socialshareHashtags) : '';
            urlString += '&picture=';
            if (ctrl.socialshareMedia) urlString += encodeURIComponent(ctrl.socialshareMedia);

            $window.open(
              urlString,
              'Facebook', 'toolbar=0,status=0,resizable=yes,width=' + winWidth + ',height=' + winHeight +
              ',top=' + ($window.innerHeight - winHeight) / 2 + ',left=' + ($window.innerWidth - winWidth) / 2);
          }
          function pinterestShare() {
            var winWidth = 673,
              winHeight = 413;

            var urlString = 'https://www.pinterest.com/pin/create/button/';
            urlString += '?url=' + encodeURIComponent(ctrl.socialshareUrl);
            urlString += '&media=' + encodeURIComponent(ctrl.socialshareMedia);
            urlString += '&description=' + encodeURIComponent(ctrl.socialshareText);


            $window.open(
              urlString,
              'pinterest', 'toolbar=0,status=0,resizable=yes,width=' + winWidth + ',height=' + winHeight +
              ',top=' + ($window.innerHeight - winHeight) / 2 + ',left=' + ($window.innerWidth - winWidth) / 2);
          }
          function twitterShare() {
            var winWidth = 673,
              winHeight = 487;

            var urlString = 'https://www.twitter.com/intent/tweet?';
            urlString += ctrl.socialshareText ? 'text=' + encodeURIComponent(ctrl.socialshareText) : '';
            urlString += ctrl.socialshareHashtags ? '&hashtags=' + encodeURIComponent(ctrl.socialshareHashtags) : '';
            urlString += '&url=' + encodeURIComponent(ctrl.socialshareUrl);

            $window.open(
              urlString,
              'Twitter', 'toolbar=0,status=0,resizable=yes,width=' + winWidth + ',height=' + winHeight +
              ',top=' + ($window.innerHeight - winHeight) / 2 + ',left=' + ($window.innerWidth - winWidth) / 2);
          }
          function googleplusShare() {
            var winWidth = 400,
              winHeight = 640;

            $window.open(
              'https://plus.google.com/share?url=' + encodeURIComponent(ctrl.socialshareUrl),
              'Google+', 'toolbar=0,status=0,resizable=yes,width=' + winWidth + ',height=' + winHeight +
              ',top=' + ($window.innerHeight - winHeight) / 2 + ',left=' + ($window.innerWidth - winWidth) / 2);
          }
          function emailShare() {
            ModalService.show(
              '/Template/Modal/ModalSendByEMail',
              {
                ViewEmail: ctrl.socialshareEmail,
                Url: ctrl.socialshareUrl
              },
              null,
              'modalSendByEMailCtrl',
              null,
              null,
              {
                modalTitle: ctrl.modalTitle,
                resultMessage: ctrl.resultMessage
              }
            );
          }

        }]
      };
    });

})();
